import { render, staticRenderFns } from "./Briefing.vue?vue&type=template&id=2e57f918&scoped=true&"
import script from "./Briefing.vue?vue&type=script&lang=ts&"
export * from "./Briefing.vue?vue&type=script&lang=ts&"
import style0 from "./Briefing.vue?vue&type=style&index=0&id=2e57f918&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e57f918",
  null
  
)

export default component.exports